<template>
  <div class="app" id="app">
    <transition name="fade-transform" mode="out-in">
      <router-view :key="$route.fullPath"/>
    </transition>
    <!-- <transition name="fade-transform" mode="out-in">
      <router-view/>
    </transition>-->
    <!-- <transition :name="transitionName">
      <keep-alive :include="/keep/">
        <router-view class="child-view"></router-view>
      </keep-alive>
    </transition>-->
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {},
  data() {
    return {}
  },
  created() {
    // 判断是否是ie浏览器
    this.isIeBrowser()
  },
  methods: {
    // 判断是否是ie浏览器
    isIeBrowser() {
      let ms_ie = false
      let ua = window.navigator.userAgent
      let old_ie = ua.indexOf('MSIE ')
      let new_ie = ua.indexOf('Trident/')
      if (old_ie > -1 || new_ie > -1) {
        ms_ie = true
      }

      if (ms_ie) {
        document.documentElement.className += ' ie'
      }
    }
  }
}
</script>

<style lang="less">
.app {
  height: 100%;
}
/* 
enter-active 定义进入过渡的结束状态
leave-active 定义离开过渡的结束状态
 */
// .fade-transform-leave-active,
// .fade-transform-enter-active {
//   transition: all 0.05s;
// }

// /*
// enter定义进入过渡的开始状态
//  */
// .fade-transform-enter {
//   opacity: 0;
//   // transform: translateX(-30px);
// }
// /*
// leave-to离场动画结束后的状态
//  */
// .fade-transform-leave-to {
//   // opacity: 0;
//   // transform: translateX(30px);
// }
</style>



// WEBPACK FOOTER //
// src/App.vue